import { useThemeColor } from "@/hooks/useThemeColor";
import { useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { ThemedText } from "./ThemedText";

const MAX_LINES = 4;

export function PostDescription({ text }: { text: string }) {
  const { t } = useTranslation();
  const color = useThemeColor({}, "text");
  const [expanded, setExpanded] = useState(false);
  const [isLong, setIsLong] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const measure = () => {
      if (expanded) return;
      setIsLong(el.scrollHeight > el.clientHeight + 1);
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [text, expanded]);

  return (
    <div style={{ paddingTop: 8, paddingBottom: 8, marginBottom: 8 }}>
      <div
        ref={ref}
        style={
          {
            color,
            fontSize: 16,
            lineHeight: "24px",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            ...(expanded
              ? {}
              : {
                  display: "-webkit-box",
                  WebkitLineClamp: MAX_LINES,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                }),
          } as React.CSSProperties
        }
      >
        {text}
      </div>
      {isLong && (
        <ThemedText
          style={
            { color: "#767676", marginTop: 4, cursor: "pointer" } as any
          }
          onPress={(e?: any) => {
            e?.stopPropagation?.();
            setExpanded((v) => !v);
          }}
        >
          {expanded ? t("SHOW_LESS") : t("READ_MORE")}
        </ThemedText>
      )}
    </div>
  );
}
